import React from 'react';
import { recommendations } from '../../data/programData';

const RecommendationsSection = () => (
  <div className="space-y-6">
    <div className="text-center mb-6">
      <h2 className="text-3xl font-bold text-gray-900">Strategic Recommendations</h2>
      <p className="text-gray-600 mt-2">Evidence-based action items for program enhancement</p>
    </div>

    <div className="grid grid-cols-1 gap-6">
      {recommendations.map((rec, index) => (
        <div key={index} className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-xl font-semibold text-gray-900">{rec.title}</h3>
            <span className={`px-3 py-1 rounded text-xs font-medium ${
              rec.priority === 'HIGH' 
                ? 'bg-red-100 text-red-800' 
                : 'bg-yellow-100 text-yellow-800'
            }`}>
              {rec.priority} PRIORITY
            </span>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <span className="text-sm font-medium text-gray-500">Timeline</span>
              <p className="text-gray-900">{rec.timeline}</p>
            </div>
            <div className="md:col-span-2">
              <span className="text-sm font-medium text-gray-500">Expected Impact</span>
              <p className="text-gray-900">{rec.impact}</p>
            </div>
          </div>
          
          <div>
            <span className="text-sm font-medium text-gray-500 block mb-2">Action Items</span>
            <ul className="list-disc pl-6 space-y-1">
              {rec.actions.map((action, actionIndex) => (
                <li key={actionIndex} className="text-gray-700">{action}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>

    <div className="mt-8 p-4 border-l-4 border-green-200 bg-green-50">
      <strong>Implementation Priority:</strong> Focus on high-priority recommendations to maximize immediate impact while building foundation for long-term success.
    </div>
  </div>
);

export default RecommendationsSection;
